import {Component} from '@angular/core';

@Component({
  selector: 'mobile-logout-component',
  template: ` <div fxFlexFill fxLayoutAlign="center center">
    <span class="mat-display-4">Logged out.</span>
  </div>`,
})
export class MobileLoggedOutComponent {}
